import Cookies from 'js-cookie';

export const doLoginDsl = (token) => {
  Cookies.set('tokendsl', token);
};

export const doLogout = () => {
  Cookies.remove('tokendsl');
};
